// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6s-0";
export var startPickingButton = "_6s-1";